/**
 * Collapsed wrapper for the long-form guide content below a rules list.
 * Keeps the reference material one click away without pushing the table up.
 */
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface GuideAccordionProps {
  title?: string;
  children: React.ReactNode;
}

const GuideAccordion = ({ title = 'How these rules work', children }: GuideAccordionProps) => (
  <Accordion
    disableGutters
    elevation={0}
    sx={{
      mt: 2,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      '&:before': { display: 'none' },
      overflow: 'hidden',
    }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <HelpOutlineIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
    </AccordionSummary>
    {/* Let the guide panel keep its own padding; only neutralize its card
        chrome (margin/border/shadow/background) so it blends into the accordion.
        Don't override its padding here — doing so wins on specificity and
        leaves the content flush against the edges. */}
    <AccordionDetails sx={{ p: 0, '& > .MuiPaper-root': { m: 0, border: 'none', boxShadow: 'none', backgroundColor: 'transparent' } }}>
      {children}
    </AccordionDetails>
  </Accordion>
);

export default GuideAccordion;
